<template>
    <div class="my-1 ctrb-list" id="introContributor">
        <svg
            id="btn_product_intro"
            class="btn-intro-contributor"
            fill="#7D2DBD"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            @click="() => startIntro()"
        >
            <path
                d="M11.188 4.781c6.188 0 11.219 5.031 11.219 11.219s-5.031 11.188-11.219 11.188-11.188-5-11.188-11.188 5-11.219 11.188-11.219zM11.063 8.906c-0.313 0.375-0.469 0.813-0.469 1.281 0 0.375 0.125 0.688 0.313 0.906 0.219 0.219 0.531 0.344 0.844 0.344 0.438 0 0.844-0.188 1.156-0.563 0.281-0.344 0.438-0.844 0.438-1.375 0-0.313-0.094-0.594-0.313-0.813s-0.531-0.344-0.844-0.344c-0.406 0-0.813 0.188-1.125 0.563zM8.219 15.375l0.375 0.406c0.281-0.313 0.563-0.563 0.75-0.719 0.188-0.125 0.344-0.188 0.469-0.188 0.094 0 0.188 0.031 0.25 0.094 0.031 0.094 0.063 0.188 0.063 0.344 0 0.781-0.094 1.281-0.5 3.156s-0.625 3.25-0.625 4.156c0 0.344 0.063 0.594 0.188 0.75 0.094 0.156 0.281 0.281 0.531 0.281 0.406 0 1-0.313 1.688-0.844 0.688-0.563 1.375-1.344 2.125-2.344l-0.406-0.344c-0.25 0.313-0.5 0.531-0.688 0.688-0.188 0.125-0.344 0.25-0.469 0.25-0.094 0-0.188-0.094-0.25-0.156-0.031-0.094-0.063-0.219-0.063-0.406 0-0.125 0.031-0.531 0.156-1.25 0.094-0.719 0.063-0.719 0.25-1.781 0.031-0.313 0.125-0.75 0.219-1.281 0.25-1.594 0.406-2.563 0.406-2.875 0-0.281-0.094-0.531-0.188-0.688-0.125-0.156-0.313-0.219-0.531-0.219-0.375 0-0.875 0.281-1.563 0.781-0.688 0.531-1.375 1.25-2.188 2.188z"
            ></path>
        </svg>
        <div class="d-flex align-center">
            <span class="form-label f-poppin fs-5 ml-2 mb-5 fw-medium">Participant(s)</span>
            <v-spacer></v-spacer>
        </div>
        <!-- <div class="d-flex justify-content-between">
          <span>Nom</span><span>Nom</span><span>Nom</span><span>Nom</span><span>Nom</span>
        </div>-->
        <ARParticipant
            v-for="(participant, index) in participants"
            :key="index"
            :prestation="prestation_"
            :client="participant"
            :shouldTakeAll="shouldTakeAll"
            :loading="loading_"
            :setToZero="prestation.setToZero"
            v-on:count-changed="refreshContributorsData"
        >
        </ARParticipant>
        <div class="mx-4" v-if="showCloseSharingSwitcher()">
            <div class="row px-0 d-flex justify-content-left">
                <h6 class="ppv2-text-black fw-meduim fs-14 f-poppin ps-0 col-10 my-2 align-items-center">
                    Autoriser le mixage des groupes
                </h6>
                <v-switch
                    class="col-2 align-items-center"
                    hide-details
                    v-model="enableMixing"
                    inset
                    @change="handleCloseBooking()"
                ></v-switch>
            </div>
        </div>
    </div>
</template>

<script>
import ARParticipant from './ARParticipant.vue'
import ActivityManager from '../../_core/ActivityManager'
import introJs from 'intro.js'
export default {
    props: ['prestation', 'participants', 'shouldTakeAll', 'loading', 'space', 'nbMaxTicket'],
    components: { ARParticipant },
    data: () => {
        return {
            // nbFreePlaces: 0,
            eventAvailablePlaces: 0,
            enableMixing: true,
            // setToZero: 0,
            loading_: false,
            loadingNbFreePlaces: false,
            prestation_: null,
            debug: false, // Enable logging only in development mode
        }
    },
    async mounted() {
        this.loading_ = this.loading
        // this.debug = process.env.NODE_ENV === 'development' // Enable logging only in development mode
    },
    async beforeMount() {
        this.prestation_ = this.prestation
        this.init()
    },
    methods: {
        async init() {
            if (this.prestation_.nbFreePlaces === undefined) this.$set(this.prestation_, 'nbFreePlaces', 0)
            if (this.prestation_.setToZero === undefined) this.$set(this.prestation_, 'setToZero', 0)

            if (this.prestation_.subcategory.slug.toLowerCase() === 'vr') {
                this.$set(this.prestation_, 'nbFreePlaces', this.nbMaxTicket)
                this.$set(this.prestation_, 'setToZero', this.prestation_.setToZero + 1)
            } else {
                this.eventAvailablePlaces =
                    this.prestation_.subcategory.slug.toLowerCase() === 'events'
                        ? (await this.getAvailableEventPlaces(this.prestation_.id, this.prestation_.start)) ?? 0
                        : 0

                const nbFreePlaces =
                    (this.prestation_.subcategory.slug.toLowerCase() === 'events'
                        ? this.eventAvailablePlaces
                        : Math.min(
                              this.space?.capacity ?? this.prestation_.selectedSpace?.capacity ?? 0,
                              this.prestation_.max_contributors ?? 0
                          )) ?? 0

                this.$set(this.prestation_, 'nbFreePlaces', nbFreePlaces)
            }
        },
        showCloseSharingSwitcher() {
            console.log('showCloseSharingSwitcher', this.prestation_)
            let show = false
            let sum = this.prestation_.selectedClients.reduce((accumulator, currentObject) => {
                return accumulator + currentObject.count
            }, 0)
            if (this.prestation_.subcategory.slug.toLowerCase() == 'paintball' && sum >= this.prestation_.type) show = true
            return show
        },
        handleCloseBooking() {
            this.$emit('handleCloseBooking', this.enableMixing, this.prestation_.id)
        },
        refreshContributorsData(client, count, presta) {
            // console.log('refreshContributorsData', client, count)
            if (this.prestation_.uid == presta.uid) {
                let nbPlaces = 0
                presta.selectedClients.find((x) => {
                    return x.id == client.id
                }).count = count
                presta.selectedClients.forEach((element) => {
                    if (this.shouldTakeAll) {
                        if (!element.isPrincipal) {
                            nbPlaces += element.count
                        }
                    } else {
                        nbPlaces += element.count
                    }
                })
                if (this.prestation_.subcategory.slug.toLowerCase() == 'vr') {
                    this.prestation_.nbFreePlaces = this.nbMaxTicket - nbPlaces
                } else {
                    this.prestation_.nbFreePlaces =
                        (this.prestation_.subcategory.slug.toLowerCase() == 'events'
                            ? this.eventAvailablePlaces
                            : Math.min(
                                  this.space?.capacity ?? this.prestation_.selectedSpace.capacity,
                                  this.prestation_.max_contributors ?? 0
                              )) - nbPlaces
                }
                if (this.shouldTakeAll) {
                    presta.selectedClients.find((x) => {
                        return x.isPrincipal
                    }).count = this.prestation_.nbFreePlaces
                }
                // Bubble up so the parent (Prestation.vue) can refresh the price
                // against the degressive lot tiers (lot_box_price_prestations).
                this.$emit('count-changed', client, count, presta)
            }
        },
        async getAvailableEventPlaces(event, startDate) {
            this.loadingNbFreePlaces = true
            let nbAvailablePlaces = (await ActivityManager.getAvailableEventPlaces(event, startDate)) ?? 0
            this.loadingNbFreePlaces = false
            return nbAvailablePlaces
        },
        handleLoading_() {
            this.loading_ = this.loading || this.loadingNbFreePlaces
        },
        async updateFreePlaces(space) {
            this.eventAvailablePlaces =
                this.prestation_.subcategory.slug.toLowerCase() === 'events'
                    ? (await this.getAvailableEventPlaces(this.prestation_.id, this.prestation_.start)) ?? 0
                    : 0

            if (this.prestation_.subcategory.slug.toLowerCase() === 'vr') {
                this.$set(this.prestation_, 'nbFreePlaces', this.nbMaxTicket)
            } else {
                const nbFreePlaces =
                    (this.prestation_.subcategory.slug.toLowerCase() === 'events'
                        ? this.eventAvailablePlaces
                        : Math.min(space?.capacity ?? 0, this.prestation_.max_contributors ?? 0)) ?? 0

                this.$set(this.prestation_, 'nbFreePlaces', nbFreePlaces)
            }
        },
        startIntro() {
            introJs()
                .setOptions({
                    showBullets: false,
                    doneLabel: 'Compris',
                    steps: [
                        {
                            element: document.querySelector('#introContributor'),
                            intro: "Cette zone vous permet d'ajouter et d'affecter des options de location et d'achat à tous les clients associés à la réservation. Les options sont ajustées individuellement pour chaque client, ce qui permet d'avoir une commande spécifique à chaque client.",
                        },
                    ],
                })
                .start()
        },
    },
    watch: {
        'prestation_.selectedSpace'(val) {
            if (this.debug) console.log('Watcher triggered: prestation_.selectedSpace', val)
            this.updateFreePlaces(val)
        },

        'prestation_.selectedClients'(val) {
            if (this.debug) console.log('Watcher triggered: prestation_.selectedClients', val)
            this.init()
        },

        nbMaxTicket(val) {
            if (this.debug) console.log('Watcher triggered: nbMaxTicket', val)
            this.init()
        },

        loading(val) {
            if (this.debug) console.log('Watcher triggered: loading', val, this.loading_)
            this.handleLoading_()
        },
        loading_(val) {
            if (this.debug) console.log('Watcher triggered: loading_', val, this.loading_)
            this.handleLoading_()
        },
    },
}
</script>
<style scoped>
.invit .v-input__control {
    border-radius: 24px;
    background: #f4f4f4;
}

.invit .v-input__control > .v-input__slot:before,
.invit .v-input__control > .v-input__slot:after {
    border: none !important;
}

.v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot,
.v-text-field--filled.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot,
.v-text-field--filled.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot,
.v-text-field--full-width.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot,
.v-text-field--full-width.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot {
    min-height: 51px;
}

.v-text-field--filled > .v-input__control > .v-input__slot {
    border: 1px solid #e2e8f0 !important;
}

.prix .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
    background: #fff !important;
    border: 1px solid #e2e8f0 !important;
    color: #94a3b8;
}
.btn-intro-contributor {
    position: relative;
    top: 25px;
    left: 145px;
    z-index: 9;
    min-width: 25px !important;
    height: 25px !important;
    cursor: pointer;
}
</style>
